import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { lang } from "../../lang";
import { ROUTE_TYPE } from "../../HelperSrc";
import { changeLanguage } from "../../actions/changeLanguage";
import { Dropdown } from "../../components/molecules/Dropdown";
import BookLockIcon from "@mui/icons-material/Book";
import BookIcon from "@mui/icons-material/LibraryBooks";
import FileOutlineIcon from "@mui/icons-material/FileCopy";
import TableIcon from "@mui/icons-material/TableChart";
import DownloadOutlineIcon from "@mui/icons-material/CloudDownload";
import UserIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsOutlineIcon from "@mui/icons-material/SettingsOutlined";
import LogoutIcon from "@mui/icons-material/ExitToAppOutlined";
import LangIcon from "@mui/icons-material/Language";
import { getDownloadList } from "../../actions/getDownloadList";
import { MenuItem } from "../../interface";
import { catchEndpoint } from "../../catchEndpoint";
import { store as uiStore } from "../../store/ui";

@observer
class AppHeaderBase extends React.Component<
    {
        title?: string;
        wbId?: string;
        locked?: boolean;
    } & RouteComponentProps
> {
    public handleClickMenuItem = (menuitem: MenuItem) => {
        const { wbId } = this.props;
        const wb = wbId;
        if (!wb) return;
        if (menuitem.key === "files") {
            this.setState({ workbookMenu: false });
            this.props.history.push(`/workbook/${wb}/files`);
        } else if (menuitem.key === "download") {
            this.setState({ workbookMenu: false });
            getDownloadList(wb).catch(catchEndpoint);
        } else if (menuitem.key === "downloadonlynew") {
            this.setState({ workbookMenu: false });
            getDownloadList(wb, true).catch(catchEndpoint);
        } else if (menuitem.key === "view") {
            this.setState({ workbookMenu: false });
            this.props.history.push(`/workbook/${wb}`);
        }
    };

    public render() {
        const { history, title, locked } = this.props;
        return (
            <div className="view_header">
                <div className="menu">
                    {title && (
                        <Dropdown
                            icon={locked ? BookLockIcon : BookIcon}
                            title={title || ""}
                            alignLeft
                            items={[
                                {
                                    key: "files",
                                    name: lang.manageFiles,
                                    icon: FileOutlineIcon
                                },
                                {
                                    key: "view",
                                    name: lang.viewTables,
                                    icon: TableIcon,
                                    "data-at_id": "workbook_view_tables"
                                },
                                {
                                    key: "download",
                                    name: lang.downloadAll,
                                    icon: DownloadOutlineIcon
                                },
                                {
                                    key: "downloadonlynew",
                                    name: lang.downloadOnlyNew,
                                    icon: DownloadOutlineIcon
                                }
                            ]}
                            onClick={this.handleClickMenuItem}
                            menuWidth={200}
                            data-at_id="workbook_menu"
                        />
                    )}
                    <Dropdown
                        icon={UserIcon}
                        title={""}
                        data-at_id="profile_menu"
                        items={[
                            {
                                key: "profile",
                                name: lang.settings,
                                icon: SettingsOutlineIcon,
                                "data-at_id": "profile_button"
                            },
                            { key: "logout", name: lang.logout, icon: LogoutIcon, "data-at_id": "logout_button" }
                        ]}
                        onClick={(e: MenuItem) => {
                            if (e.key === "profile") {
                                history.push(ROUTE_TYPE.PROFILE, { userId: uiStore.userid });
                            } else if (e.key === "logout") {
                                history.push(ROUTE_TYPE.LOGOUT);
                            }
                        }}
                    />
                    <Dropdown
                        icon={LangIcon}
                        title={""}
                        data-at_id="menu_locale"
                        items={[
                            { key: "ja-JP", name: lang.japanese, "data-at_id": "menu_locale_ja_jp" },
                            { key: "en-US", name: lang.english, "data-at_id": "menu_locale_en_us" }
                        ]}
                        onClick={(e: MenuItem) => {
                            const localeSplit = e.key.split("-");
                            const language = localeSplit[0];
                            const country = localeSplit[1].toLowerCase();

                            changeLanguage(language, country);
                        }}
                    />
                </div>
            </div>
        );
    }
}

const AppHeader = withRouter(AppHeaderBase);

export { AppHeader };
